import { render, staticRenderFns } from "./BioPreview.vue?vue&type=template&id=7b03ee6f&scoped=true&"
import script from "./BioPreview.vue?vue&type=script&lang=js&"
export * from "./BioPreview.vue?vue&type=script&lang=js&"
import style0 from "./BioPreview.vue?vue&type=style&index=0&id=7b03ee6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b03ee6f",
  null
  
)

export default component.exports